import React from "react";
import Paper from "@material-ui/core/Paper";
import {QRCodeSVG} from 'qrcode.react';
import {InputText} from "primereact/inputtext";
import {Button} from "primereact/button";
import {Card} from "primereact/card";
import SubtitleLabel from "../../app/Title/SubtitleLabel/SubtitleLabelView";
import {InfoRounded, Looks3Rounded, LooksOneRounded, LooksTwoRounded, MenuBookRounded} from '@material-ui/icons';
import {Divider} from "@material-ui/core";
import logoGooglePlay from "../../img/appStores/googlePlay.png";
import logoAppStore from "../../img/appStores/appStore.png";
import TitlePage from "../../app/Title/TitlePage/TitlePageView";
import PropTypes from "prop-types";

const MFA = ({
                 ...props
             }) => {
    return (
        <React.Fragment>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>

                <TitlePage title= {props.qrUrl ? "Configuración de Verificación de dos pasos" :
                    "Verificación de dos pasos"}/>
                <Divider/>
                {props.qrUrl !== "" &&
                    <div className="p-grid">
                        <div className="p-col-12"
                             style={{paddingTop: '2%', paddingLeft: '4%', paddingRight: '15%' }}>
                            <SubtitleLabel icon={<LooksOneRounded /> }
                                           header={"Descarga la aplicación Google Authenticator."} />
                        </div>
                        <div className="p-col-12"
                             style={{ paddingLeft: '8%', paddingRight: '15%' }}>
                            <a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&pcampaignid=web_share"
                               target="_blank" rel="noopener noreferrer">
                                <img alt="lightBulb" src={logoGooglePlay} style={{height: '25px'}}/>
                            </a>
                            &nbsp; &nbsp; &nbsp;
                            <a href="https://apps.apple.com/us/app/google-authenticator/id388497605"
                               target="_blank" rel="noopener noreferrer">
                                <img alt="lightBulb" src={logoAppStore} style={{height: "32px"}}/>
                            </a>
                        </div>
                        <div className="p-col-12"  style={{ paddingLeft: '8%', paddingRight: '25%'}}>
                            <Card className="card-info" >
                                <tr>
                                    <td valign={"middle"}>
                                        <MenuBookRounded fontSize={"large"}/> &nbsp; &nbsp;
                                        <InfoRounded fontSize={"large"}/> &nbsp; &nbsp;
                                    </td>
                                    <td valign={"middle"} align='center'>
                                        <SubtitleLabel isBold={true}
                                                       header={"¿Necesitas ayuda con la configuración?"} />
                                        <Button label="Ver el Manual Completo aquí"
                                                icon="pi pi-arrow-circle-right" iconPos={"right"}
                                                className="p-button-secondary"
                                                type="button"
                                                onClick={props.redirectToManual}
                                        />
                                    </td>
                                </tr>
                            </Card>
                        </div>
                        <div className="p-col-12"
                             style={{paddingTop: '1%', paddingLeft: '4%', paddingRight: '15%'}}>
                            <SubtitleLabel icon={<LooksTwoRounded /> }
                                           header={"Escanea el siguiente código QR."} />
                        </div>
                        <div className="p-col-12"
                             style={{paddingTop: '1%', paddingLeft: '8%', paddingRight: '15%'}}>
                            <QRCodeSVG
                                value={props.qrUrl}
                                size={150}
                                level="M"
                                marginSize={2}
                            />
                        </div>
                        <div className="p-col-12"><Divider/></div>
                        <div className="p-col-12"
                             style={{paddingTop: '2%', paddingLeft: '4%', paddingRight: '15%'}}>
                            <SubtitleLabel icon=<Looks3Rounded />
                                           header={"Ingresar el código de 6 dígitos que genera la app."} />
                        </div>
                    </div>

                }
                <div className="p-grid">
                    { props.qrUrl === "" &&
                        <div className="p-col-12"
                             style={{paddingTop: '2%', paddingLeft: '1%'}}>
                            <SubtitleLabel header={"Ingresar el código de 6 dígitos que genera la app."} />
                        </div>
                    }
                    <div className="p-col-12"
                         style={{paddingBottom:'1%', paddingLeft: '8%', paddingRight: '70%'}}>
                        <InputText
                            keyfilter={/^[0-9]*$/}
                            maxLength={6}
                            id="token"
                            value={props.token}
                            onChange={props.updateToken}
                            autoComplete="off"
                            autoFocus
                        />
                    </div>
                    <div className="p-col-12"
                         style={{paddingBottom: '2%', paddingLeft: '8%'}}>
                        <Button label="Verificar"
                                onClick={props.singInMfa}/> &nbsp; &nbsp; &nbsp;
                        <Button label="Cancelar" className="p-button-secondary"
                                onClick={props.cancelMfa}/>
                    </div>
                </div>

            </Paper>
        </React.Fragment>
    )
};

export default (MFA);

MFA.propTypes = {
    redirectToManual: PropTypes.func.isRequired,
    qrUrl: PropTypes.string.isRequired,
    token: PropTypes.string.isRequired,
    updateToken: PropTypes.func.isRequired,
    singInMfa: PropTypes.func.isRequired,
    cancelMfa: PropTypes.func.isRequired,
};